<template>
  <div class="share-modal" v-if="showShareModal">
    <div class="share-overlay" @click="closeShareModal"></div>
    <div class="share-content">
      <div class="share-title">{{ $t("分享到") }}</div>
      <div class="share-platforms">
        <div class="platform" @click="shareTo('facebook')">
          <img src="@/img/donation/icon_grzx_facebook@2x.png" alt="Facebook" />
          <span>Facebook</span>
        </div>
        <div class="platform" @click="shareTo('line')">
          <img src="@/img/donation/icon_grzx_line@2x.png" alt="Line" />
          <span>Line</span>
        </div>
        <!-- <div class="platform" @click="shareTo('twitter')">
					<img src="@/img/share/twitter.png" alt="Twitter" />
          <span>Twitter</span>
        </div> -->
      </div>
      <button class="share-cancel" @click="closeShareModal">
        {{ $t("取消") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showShareModal: false,
      shareData: {
        title: "",
        description: "",
        image: "",
        url: "",
      },
    };
  },
  mounted() {
    // 监听全局分享事件
    this.$root.$on('open-share-modal', this.openShareModal);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off('open-share-modal');
  },
  methods: {
    openShareModal(data) {
      this.shareData = {
        title: data.title || document.title,
        description: data.description || "",
        image: data.image || require("@/img/login/dluyclogo.png"),
        url: data.url || window.location.href,
      };
      this.showShareModal = true;
    },
    closeShareModal() {
      this.showShareModal = false;
    },
    shareTo(platform) {
      let shareUrl = "";
      switch (platform) {
        case "facebook":
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            this.shareData.url
          )}`;
          break;
        case "line":
          shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
            this.shareData.url
          )}`;
          break;
        case "twitter":
          shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            this.shareData.title
          )}&url=${encodeURIComponent(this.shareData.url)}`;
          break;
      }
      window.open(shareUrl, "_blank", "width=600,height=400");
      this.closeShareModal();
    },
  },
};
</script>

<style scoped>
.share-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.share-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.share-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-radius: 12px 12px 0 0;
  padding: 20px;
}
.share-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}
.share-platforms {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
.platform {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.platform img {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}
.share-cancel {
  width: 100%;
  padding: 10px;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
}
</style>
